export default __webpack_public_path__ + "static/media/Banner Sound.d9b33745.mp3";